type PointerPress = Readonly<{ pointerId: number; button: number }>;
type PointerActivation = Readonly<{ type?: string; pointerId?: number; button: number; detail: number }>;
type ContextKey = Readonly<{ key: string; shiftKey: boolean }>;

/** A dismissed popup owns only the activations generated by its outside press. */
export class MenuPress {
  private pending: PointerPress | null = null;
  private consumed = 0;

  reset(): void { this.pending = null; this.consumed = 0; }
  arm(press: PointerPress): void { this.pending = { pointerId: press.pointerId, button: press.button }; this.consumed = 0; }
  keyDown(event: ContextKey): void {
    // A physical contextmenu may also have detail=0. Retire ownership on the
    // actual keyboard request instead of mistaking that value for its origin.
    if (event.key === 'ContextMenu' || event.key === 'F10' && event.shiftKey) this.reset();
  }
  consume(event: PointerActivation): boolean {
    const press = this.pending, kind = event.type ?? 'click';
    const flag = kind === 'click' ? 1 : kind === 'contextmenu' ? 2 : kind === 'auxclick' ? 4 : 0;
    // Keyboard clicks remain available. MouseEvent-only browsers omit the
    // pointer id; a fresh pointerdown still retires the previous press first.
    if (!press || !flag || this.consumed & flag || event.button !== press.button ||
        event.pointerId !== undefined && event.pointerId !== press.pointerId ||
        kind === 'click' && event.detail === 0 ||
        kind === 'contextmenu' && press.button !== 2 ||
        kind === 'auxclick' && press.button !== 1 && press.button !== 2) return false;
    this.consumed |= flag;
    // Right-button browsers may emit contextmenu on down and auxclick on up,
    // or emit just one. Keep each sibling owned once until both arrive or a
    // fresh press, cancellation, keyboard request or lifecycle reset retires it.
    if (press.button !== 2 || (this.consumed & 6) === 6) this.reset();
    return true;
  }
}
